import focusElement from './focusElement';
import smoothlyScrollIntoView from './smoothlyScrollIntoView';
/**
 * trigger focus on an element and smoothly scroll it into view
 * (using native methods)
 */
const focusAndSmoothlyScrollIntoView = (element) => {
    // focus element and indicate to the browser not to scroll
    // note: preventScroll is not recognised by some mobile browsers,
    // there are open bugs for this with Chromium and Mozilla though,
    // so we will use this rather than having to replace a custom approach later
    focusElement(element, { preventScroll: true });
    smoothlyScrollIntoView(element);
};
export default focusAndSmoothlyScrollIntoView;
//# sourceMappingURL=focusAndSmoothlyScrollIntoView.js.map